import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { niceList } from '@shared/utils/strings';

@Pipe({ name: 'list' })
export class ListPipe implements PipeTransform {
    transform<T = any>(value: T[], pluck?: keyof T): any {
        if (!value) {
            return value;
        }

        if (pluck) {
            return niceList(value.map(v => v[pluck]));
        }

        return niceList(value);
    }
}
